module.exports = __webpack_public_path__ + "img/mtasa.39c1b38f.png";